import React from 'react'

import Ripple from '../../../../../../../../../../dumb/Ripple';
import {Box} from "@material-ui/core";

module.exports = ({
  checked,
  ...props
}) => {
  return (
    <Box height="4.5rem">
      <Ripple
        {...props}
        className={`layoutRow fhaC fvaC h wmin76 w ph10 bs b1 bc0 f12 fw4 lh lts0em
          tdN olN bc0:not[.disabled]:not[.checked]:h r6 dn
          (bg|bc)A3A7AC.disabled.checked o50.disabled:not[.checked]
          (cF|(bg|bc)5B47FF|bg4B37EF:not[.disabled]:h!).checked `
          + (checked ? 'checked ' : '')
          + (props.className || '')
        }
      />
    </Box>
  );
};
